import { PageGrid } from "@/modules/pages";
import { axios } from "../../../core/axios";
import { GetGridParams, SaveGridRequest } from "../types";

export const gridEndpoints = {
    getGrid: async (params: GetGridParams): Promise<PageGrid | undefined> => {
        try {
            const response = await axios.get<PageGrid>(`/grids`, { params });
            return response.data;
        } catch (error) {
            console.error("Error fetching grid:", error);
            return undefined;
        }
    },

    saveGrid: async (data: SaveGridRequest): Promise<PageGrid | undefined> => {
        try {
            const response = await axios.put<PageGrid>(`/grids`, data);
            return response.data;
        } catch (error) {
            console.error("Error saving grid:", error);
            return undefined;
        }
    },
};
